/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function () {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  // console.log(vw);;

}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function () {
  let timer = setInterval(function(){
    if($(shadowRootHd).find('.endo2026-l-header')[0]) {
      clearInterval(timer);
      init();
    }

    function init() {
      $('a[href*="#"], .js-scrollAnc').add($(shadowRootHd).find('a[href*="#"]')).not('#section-top a').click(function () {
        var speed = 500;
        var href = $(this).attr("href");
        var dataScrollHref = $(this).attr('data-scroll-href');

        if(dataScrollHref) href = dataScrollHref;

        //#の前にもURLがある場合#以降を抽出
        var arr = href.split('/#');

        if(arr.length > 1) {
          //リンク先が別ページだったらページ内スクロールはしない
          var nowUrl = window.location.pathname;
          var nextUrl = arr[0];

          nowUrl = nowUrl.replace(/\/$/, "");
          nextUrl = nextUrl.replace(/\/$/, "");

          if(nowUrl != nextUrl) {
            return true;
          }

          //同一ページ内のアンカーリンクを設定
          href = '#' + arr[arr.length - 1];
        }
        console.log(href);

        var target = $(href == "#" || href == "" ? 'html' : href);

        if(target[0]) {
          var position = target.offset().top;
          position -= $(shadowRootHd).find('.endo2026-l-header').innerHeight();

          if( window.location.pathname == '/support/contact-list/') {
            console.log('go');
            position -= $('.endo2026-contactList-con__itemFix').innerHeight();
          }

          $("html, body").animate({ scrollTop: position }, speed, "swing");

          //ヘッダーナビを閉じる
          $(shadowRootHd).find('.endo2026-p-hd__nav').addClass('is-eventNone');
          setTimeout(function(){
            $(shadowRootHd).find('.endo2026-p-hd__nav').removeClass('is-eventNone');
          }, 100);

          return false;
        }
      });

      checkHash();
    }
  }, 10);

  function checkHash() {
    //URLのハッシュ値を取得
    var urlHash = location.hash;
    //ハッシュ値があればページ内スクロール
    if(urlHash) {
      //スクロールを0に戻す
      $('body,html').stop().scrollTop(0);
      setTimeout(function () {
        //ロード時の処理を待ち、時間差でスクロール実行
        scrollToAnker(urlHash) ;
      }, 100);
    }
  }

  // 関数：スムーススクロール
  // 指定したアンカー(#ID)へアニメーションでスクロール
  function scrollToAnker(hash) {
    var target = $(hash);

    if(target[0]) {
      var position = target.offset().top;
      position -= $(shadowRootHd).find('.endo2026-l-header').innerHeight();
      $('body,html').stop().animate({scrollTop:position}, 500);
    }
  }
});


//スライダー
$(function () {
  $('.endo2026-home-topics__slider').each(function (index, el) {
    const $slider = $(this);
    const $prev = $('.endo2026-home-topics__controlPrev');
    const $next = $('.endo2026-home-topics__controlNext');
    const $stop = $('.endo2026-home-topics__controlStop');

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: false,
      speed: 300,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false,
      variableWidth: true
    });

    $prev.on('click', function () {
      $slider.slick('slickPrev');
    });

    $next.on('click', function () {
      $slider.slick('slickNext');
    });

    $stop.on('click', function () {
      $stop.toggleClass('is-on');

      if($stop.hasClass('is-on')) {
        $slider.slick('slickPause');
      } else {
        $slider.slick('slickPlay');
      }
    });
  });
});

//フェード
$(function () {
  var fade = $('.endo2026-u-fade, .endo2026-js-fadeAni');

  fade.each(function (index, el) {
    var t = $(this);

    setTimeout(function () {
      $(window).on('resize scroll', function (event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if (h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if (sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if (d) {
        pointD = d;
      }

      if (pointH < pointSc) {
        setTimeout(function () {
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if (nextStr) {
        var nextArr = nextStr.split(' ');
        if (nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if (nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if (nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if (nextDelay) {
                step = delay;
              }
              if (nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function (index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function () {
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  $('.endo2026-home-news__catNav').each(function (index, element) {
    const $nav = $(this);
    const $btn = $nav.find('button');
    const $list = $('.endo2026-home-news__list');
    let now = 0;

    init();
    function init() {
      $btn.eq(now).addClass('is-on');
      $list.eq(now).show();
    }

    $btn.on('click', function () {
      now = $btn.index(this);

      $btn.removeClass('is-on').eq(now).addClass('is-on');
      $list.stop().hide().eq(now).fadeIn(300);
    });
  });
})

$(function(){
  $('.endo2026-p-pulldown').each(function (index, element) {
    const $root = $(this);
    const $btn = $root.find('button');
    const $list = $root.find('ul');
    const $link = $root.find('ul li a');

    $btn.on('click', function () {
      $root.toggleClass('is-on');
      $list.stop().slideToggle(300);
    });

    $link.on('click', function () {
      $root.removeClass('is-on');
      $list.stop().slideUp(300);
    });
  });
})

$(function(){
  $('.endo2026-support-con__faq').each(function (index, element) {
    const $root = $(this);
    const $btn = $root.find('button');

    $btn.on('click', function () {
      const $dd = $(this).parent().next();

      $(this).toggleClass('is-on');
      $dd.stop().slideToggle(300);
    });
  });
})

$(function(){
  $('.endo2026-support-con__system').each(function (index, element) {
    const $root = $(this);
    const $btns = $root.find('.endo2026-support-con__systemBtns');
    const $btn = $root.find('.endo2026-support-con__systemBtns button');
    const $con = $root.find('.endo2026-support-con__systemCon');

    // $btn.eq(0).addClass('is-on');
    // $con.eq(0).stop().fadeIn(400);

    $btn.on('click', function () {
      const $t = $(this);
      const now = $btn.index(this);

      $btn.removeClass('is-on');
      $t.addClass('is-on');
      $con.hide().eq(now).stop().fadeIn(400);

      if (window.matchMedia('(max-width: 767px)').matches) {
        const l = $btn.eq(now).position().left;
        const winW = $(window).innerWidth();
        $btns.animate({
          scrollLeft: l - (winW - 40) / 2 + 65
        }, 300);
      }
    });
  });
})

$(function () {
  $('.endo2026-showroomS-kv__slider').each(function (index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 5000,
      fade: false,
      speed: 600,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false,
      variableWidth: true,
      centerMode: true
    });
  });
})

$(function(){
  $('.endo2026-projects-side__cats').each(function (index, element) {
    const $root = $(this);
    const $btn = $root.find('h3 button');
    const $list = $root.find('ul');

    $btn.on('click', function () {
      $(this).toggleClass('is-on');
      $list.stop().slideToggle(300);
    });
  });
});

$(function(){
  $('.endo2026-projectsS-gal__slider').each(function (index, element) {
    const $slider = $(this);

    $slider.slick({
      arrows: false,
      dots: false,
      asNavFor: '.endo2026-projectsS-gal__thumbs'
    });
  });
});

$(function(){
  $('.endo2026-projectsS-gal__thumbs').each(function (index, element) {
    const $slider = $(this);
    const $items = $('.endo2026-projectsS-gal__items ul');

    $items.eq(0).addClass('is-show is-showAni');

    $slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
      $slider.find(".slick-slide").each((index, el) => {
        const $this = $(el),
        slickindex = $this.attr("data-slick-index");
        if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
          if (slickindex == "-1") {
            $this.addClass("is-active-next");
          } else {
            $this.removeClass("is-active-next");
          }
        } else if (nextSlide == 0) {
          if (slickindex == slick.slideCount) {
            $this.addClass("is-active-next");
          } else {
            $this.removeClass("is-active-next");
          }
        } else {
          $this.removeClass("is-active-next");
        }
      });

      $items.removeClass('is-show is-showAni').eq(nextSlide).addClass('is-show');
      setTimeout(function(){
        $items.eq(nextSlide).addClass('is-showAni');
      }, 20);
    });

    $slider.slick({
      arrows: true,
      dots: false,
      variableWidth: true,
      centerMode: true,
      asNavFor: '.endo2026-projectsS-gal__slider',
      // swipe: false,
      focusOnSelect: true
    });
  });
});

$(function(){
  $('.js-catalog-inquiry').each(function (index, element) {
    const $btn = $(this);
    const $input = $('.endo2026-catalog-con__itemApply input');

    $input.on('change', function () {
      setHref();
    });

    setHref();

    function setHref() {
      const path = $btn.attr('data-href');
      let param = '';

      $input.filter(':checked').each(function (index, element) {
        const $t = $(this);

        if($t.val()) {
          if(param) {
            param += ',';
          }
          param += $t.val();
        }
      });

      $btn.attr('href', path + param);
    }
  });
});

$(function(){
  $('.endo2026-catalog-nav').each(function (index, element) {
    const $nav = $(this);
    const $btn = $nav.find('a, button');
    const $list = $('.endo2026-catalog-con__items');
    let now = 0;

    init();
    function init() {
      let hash = location.hash;
      if(hash) {
        hash = hash.substring(1);

        $btn.each(function (index, element) {
          const $t = $(this);

          if($t.attr('data-slug') == hash) {
            now = index;
          }
        });
      }

      $btn.removeClass('is-on').eq(now).addClass('is-on');
      $list.stop().hide().eq(now).fadeIn(300);
    }

    $btn.on('click', function () {
      now = $btn.index(this);

      $btn.removeClass('is-on').eq(now).addClass('is-on');
      $list.stop().hide().eq(now).fadeIn(300);
    });

    //URL変化チェック
    let checkUrl = window.location.href;
    setInterval(function(){
      if(checkUrl != window.location.href) {
        checkUrl = window.location.href;
        init();
        $(shadowRootHd).find('.endo2026-p-hd__nav').addClass('is-eventNone');

        setTimeout(function(){
          $(shadowRootHd).find('.endo2026-p-hd__nav').removeClass('is-eventNone');
        }, 100);
      }
    }, 30);
  });
})

$(function(){
  $('.endo2026-projects-side__catsWrap').each(function (index, element) {
    const $root = $(this);
    const $cats = $('.endo2026-projects-side__cats');
    const $check = $cats.find('input');
    const $item = $('.endo2026-projects-con__item');
    const $resetBtn = $('.endo2026-projects-side__reset button');
    const $keywordInput = $('.endo2026-projects-side__keyword input');
    const $keywordBtn = $('.endo2026-projects-side__keyword button');
    const $itemsNone = $('.endo2026-projects-con__itemsNone');

    $check.on('change', function () {
      update();
    });

    $resetBtn.on('click', function () {
      $check.prop('checked', false);
      update();
    });

    $keywordBtn.on('click', function () {
      update();
    });

    $keywordInput.on('keyup', function(e){
      if(e.key==='Enter'||e.keyCode===13){
        $keywordBtn.trigger('click');
      }
    });

    init();

    function init() {
      const paramC = getParam('c');

      if(paramC) {
        $('.endo2026-projects-side__cats input').each(function (index, element) {
          const $t = $(this);
          const slug = $t.attr('data-slug');

          if(paramC == slug) {
            $t.prop('checked', true);
            $t.parent().parent().parent().parent().find('h3 button').trigger('click');
          }

          update();
        });
      }
    }

    function getParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    //一覧更新
    function update() {
      let hitCnt = 0;
      $item.addClass('is-hide is-hideAni');

      //事例を１つづつチェック
      $item.each(function (index, element) {
        const $t = $(this);
        const $ttl = $t.find('.endo2026-projects-con__itemTtl');
        const $tag = $t.find('.endo2026-projects-con__itemTags li');
        let isHit = 0;

        const itemIndex = index;

        //チェックボックスグループごとのループ
        $cats.each(function (index, element) {
          const $t2 = $(this);
          let checkCnt = 0;

          //チェック済みチェックボックスのループ
          let isLoop = true;
          $t2.find('input').filter(':checked').each(function (index, element) {
            const $t3 = $(this);
            const slug = $t3.attr('data-slug');

            checkCnt ++;

            //条件と一致するか
            $tag.each(function (index, element) {
              if($(this).hasClass(slug)) {
                isHit ++;
                isLoop = false;
                return false;
              }
            });

            return isLoop;
          });

          //チェック0件のときは条件一致とする

          if(checkCnt == 0) {
            isHit ++;
          }
        });

        //キーワードをチェック
        if($keywordInput.val() != '') {
          const k = $keywordInput.val();
          let txt = $ttl.text() + ' ';

          $tag.each(function (index, element) {
            txt += $(this).text();
          });

          //条件と一致するか
          if(txt.match(k)) {
            isHit ++;
          }
        } else {
          isHit ++;
        }

        //ヒットしたら
        if(isHit == 4) {
          hitCnt ++;
          $t.removeClass('is-hide');

          setTimeout(function(){
            $t.removeClass('is-hideAni');
          }, 20);
        }
      });

      //ヒット無しでメッセージを表示
      if(hitCnt == 0) {
        $itemsNone.addClass('is-show');

        setTimeout(function(){
          $itemsNone.addClass('is-showAni');
        }, 20);
      } else {
        $itemsNone.removeClass('is-show is-showAni');
      }
    }
  });
})

$(function(){
  let timer = setInterval(function(){
    if ($('body').hasClass('home')) {
      $(shadowRootHd).find('.endo2026-l-header__wrap').addClass('home');
      if($(shadowRootHd).find('.endo2026-p-hd__logo img')[0]) {
        clearInterval(timer);
        init();
      }
    }
  }, 10);

  function init() {
    $(shadowRootHd).find('.endo2026-p-hd__logo img').each(function (index, element) {
      const $logo = $(this);

      $logo.addClass('is-homeScStart');

      $(window).on('scroll', function () {
        run();
      });

      run();

      function run() {
        if($(window).scrollTop() > 10) {
          $logo.addClass('is-homeSc');
        } else {
          $logo.removeClass('is-homeSc');
        }
      }
    });
  }
})

$(function(){
  $('.endo2026-facility-nav').each(function (index, element) {
    const $nav = $(this);
    const $btn = $nav.find('a, button');
    const $list = $('.endo2026-facility-con');
    let now = 0;

    function getParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    init();

    function init() {
      //GET値をチェック
      let param = getParam('anchor');

      if(param) {
        $btn.each(function (index, element) {
          const $t = $(this);

          if($t.attr('data-slug') == param) {
            now = index;
          }
        });
      } else {
        //#ハッシュをチェック
        let hash = location.hash;
        if(hash) {
          hash = hash.substring(1);

          $btn.each(function (index, element) {
            const $t = $(this);

            if($t.attr('data-slug') == hash) {
              now = index;
            }
          });
        }
      }

      $btn.removeClass('is-on').eq(now).addClass('is-on');
      $list.stop().hide().eq(now).fadeIn(300);
    }

    $btn.on('click', function () {
      now = $btn.index(this);

      $btn.removeClass('is-on').eq(now).addClass('is-on');
      $list.stop().hide().eq(now).fadeIn(300);

      history.pushState('', '', '?anchor=' + $btn.eq(now).attr('data-slug'));
      return false;
    });

    //URL変化チェック
    let checkUrl = window.location.href;
    setInterval(function(){
      if(checkUrl != window.location.href) {
        checkUrl = window.location.href;
        init();
        $(shadowRootHd).find('.endo2026-p-hd__nav').addClass('is-eventNone');

        setTimeout(function(){
          $(shadowRootHd).find('.endo2026-p-hd__nav').removeClass('is-eventNone');
        }, 100);
      }
    }, 30);
  });
})

$(function(){
  $('.endo2026-p-pulldown.-facility').each(function (index, element) {
    const $root = $(this);
    const $sel = $root.find('.endo2026-p-pulldown__sel');
    const $btn = $root.find('.endo2026-p-pulldown__btn');
    const $item = $root.find('ul li button');
    const $list = $('.endo2026-facility-con');
    let now = 0;

    $item.on('click', function () {
      const $t = $(this);
      now = $item.index(this);

      $sel.text($t.text());
      $list.stop().hide().eq(now).fadeIn(300);
    });
  });
})

$(function(){
  $('.endo2026-pickup-con__items').each(function (index, element) {
    const $root = $(this);
    const $li = $root.children('ul').children('li');

    $(window).on('resize', function () {
      run();
    });

    run();

    function run() {
      if(window.matchMedia('(min-width:768px)').matches) {
        let h = 0;
        let set = [];

        $li.each(function (index, element) {
          const $t = $(this);
          const tH = $t.find('.endo2026-pickup-con__itemInfo').innerHeight();

          if(index % 3 == 0) {
            h = 0;
            set = [];
          }

          if(tH > h) h = tH;
          set.push($t.find('.endo2026-pickup-con__itemInfo'));

          for (let i = 0; i < set.length; i++) {
            set[i].css('height', h);
          }
        });
      } else {
        $li.find('.endo2026-pickup-con__itemInfo').removeAttr('style');
      }
    }
  });
})

$(function() {
  $('.endo2026-home-news__list').each(function (index, element) {
    const max = 4; //最大表示数

    const $root = $(this);
    const $ul = $root.find('ul');
    const $li = $root.find('li');

    let listData = [];

    $li.each(function (index, element) {
      const $t = $(this);

      listData.push([$t.find('.-date').html(), $t.find('.-cat b').html(), $t.find('.-ttl').html(), $t.find('a').attr('href'), $t.find('a').attr('target')]);
    });

    $.ajax({
      url : 'https://ssl4.eir-parts.net/V4Public/eir/6932/ja/announcement/announcement_2.js',           // リクエストを送信する先のURL
      dataType : 'text',       // サーバから返されるデータの型(html, xml, json, text など)
      success : function(result) { // 成功時に実行されるコールバック関数
        const resultLines = result.split('\n');
        const resultTxt = resultLines.slice(1, -1).join('\n');
        const data = JSON.parse(resultTxt);

        if(data.item) {
          addList(data.item);
        }
      },
      error : function(request, status, error) { // 通信に失敗したときに呼ばれるコールバック関数。
          console.log(error);
          $root.removeAttr('style');
      }
    })

    function addList(data) {
      //データ整理
      for(let i in data){
        listData.push([data[i].format_date, '企業・IR', data[i].title, data[i].link, '_blank']);
      }

      listData.sort(function(a,b){
        if( a[0] < b[0] ) return 1;
        if( a[0] > b[0] ) return -1;
        return 0;
      });


      //表示
      $ul.empty();

      for (let i2 = 0; i2 < max; i2++) {
        let html = '';
        let catName = '';

        if(listData[i2][3]) {
          if(listData[i2][4]) {
            html += '<li><a href="' + listData[i2][3] + '" target="' + listData[i2][4] + '">';
          } else {
            html += '<li><a href="' + listData[i2][3] + '">';
          }
        } else {
          html += '<li><p>';
        }
        html += '  <span class="-date">' + listData[i2][0] + '</span>';
        html += '  <span class="-cat"><b>' + listData[i2][1] + '</b></span>';
        html += '  <span class="-ttl">' + listData[i2][2] + '</span>';
        if(listData[i2][3]) {
          html += '</a></li>';
        } else {
          html += '</p></li>';
        }

        $ul.append(html);
      }

      $root.removeAttr('style');
    }
  });
});

$(function() {
  $('.endo2026-p-format').each(function (index, element) {
    const $root = $(this);
    const $tb = $root.find('table');

    $tb.each(function (index, element) {
      const $t = $(this);

      $t.wrap('<div class="endo2026-p-format__tbWrap">').wrap('<div class="endo2026-p-format__tbWrap2">');
      // $t.wrap('<div class="endo2026-p-con__tbWrap">').wrap('<div class="endo2026-p-con__tbWrap2" data-simplebar data-simplebar-auto-hide="false">');
    });

    // $('.endo2026-p-con__tbWrap').each((el) => new SimpleBar(el), { autoHide: false });
  });
});

$(function() {
  $('.endo2026-contactList-con__sec').eq(0).each(function (index, element) {
    const $sec = $(this);
    const $item = $sec.find('.endo2026-contactList-con__item').eq(0);
    const $parent = $item.parent();
    const $bread = $('.endo2026-page-bread');
    let $itemFix = $item.clone();
    let isSP = false;
    let gap = 0;

    $itemFix.addClass('-fix');
    $parent.append($itemFix);
    $itemFix = $sec.find('.endo2026-contactList-con__item.-fix');
    $itemFix.wrap('<div class="endo2026-contactList-con__itemFix"><div class="endo2026-l-container">');
    $itemFix = $sec.find('.endo2026-contactList-con__itemFix');

    $(window).on('scroll', function () { run(); });
    run();
    function run() {
      if (window.matchMedia('(max-width: 991px)').matches) {
        gap = -50;
        isSP = true;
      } else {
        gap = -160;
        isSP = false;
      }

      if($(window).scrollTop() > $item.offset().top + gap) {
        $itemFix.addClass('is-on');
      } else {
        $itemFix.removeClass('is-on');
      }

      if($itemFix.offset().top + $itemFix.innerHeight() - gap > $bread.offset().top) {
        $itemFix.addClass('is-hide');
      } else {
        $itemFix.removeClass('is-hide');
      }
    }
  });
});

$(function() {
  $('.endo2026-catalog-con__claim').eq(0).each(function (index, element) {
    const $itemFix = $('.endo2026-catalog-con__claimFix');
    const $bread = $('.endo2026-page-bread');
    let isSP = false;
    let gap = 0;

    $(window).on('scroll', function () { run(); });
    run();
    function run() {
      if (window.matchMedia('(max-width: 991px)').matches) {
        gap = -50;
        isSP = true;
      } else {
        gap = -130;
        isSP = false;
      }
      if($(window).scrollTop() < $bread.offset().top - $(window).height() + gap) {
        $itemFix.addClass('is-on');
      } else {
        $itemFix.removeClass('is-on');
      }

    }
  });
});

//aタグのhrefが外部リンクの場合target="_blank"
$(function() {
  $('a[href^="http"]').not('[href*="'+location.host+'"]').attr({target:"_blank"});

  $('a[href^="http"]').filter('[href*="'+location.host+'/ir/"]').attr({target:"_blank"});
  $('a[href^="http"]').filter('[href*="'+location.host+'/hikariiku/"]').attr({target:"_blank"});

  $('a[href^="/"]').filter('[href*="/ir/"]').attr({target:"_blank"});
  $('a[href^="/"]').filter('[href*="/hikariiku/"]').attr({target:"_blank"});

  $('a[href$=".pdf"]').attr({target:"_blank"});
});

//TOPページのみフリーワード検索のactionを制御（下層はShadowDOMのヘッダーに実装）
$(function() {
  $('.-home .endo2026-p-search__catsWrap').each(function (index, element) {
      const $root = $(this);
      const $radio = $root.find('.endo2026-p-search__cats input');
      const $form = $root.find('.endo2026-p-search__form');
      const $form2Input = $root.find('.endo2026-p-search__form.-n2 .endo2026-p-search__input');

      $radio.on('change', function () {
        const now = $radio.filter(":checked").val();
        $form.removeClass('is-on').eq(now - 1).addClass('is-on');
      });
      runReset();

      $(window).on('pageshow', function () { runReset(); });
      function runReset() {
        $radio.eq(0).prop('checked', true);
        $form.removeClass('is-on').eq(0).addClass('is-on');
        $form2Input.val('');
      }
    });

    $('.-home .endo2026-p-hd__search').each(function (index, element) {
      const $root = $(this);
      const $radio = $root.find('.endo2026-p-hd__searchCats input');
      const $form = $root.find('.endo2026-p-hd__searchForm');

      $radio.on('change', function () {
        const now = $radio.filter(":checked").val();
        $form.removeClass('is-on').eq(now - 1).addClass('is-on');
        });
    });
});
